import { SidebarProvider } from '@src/app/layout';
import { useAuthentication } from '@src/features/auth';
import { Box } from '@src/shared/ui/layout';
import { WebSocketProvider } from '@src/shared/websocket';

import Main from './Main';
import Sidebar from './Sidebar';

function Navigation() {
  return (
    <Box component="nav">
      <Sidebar />
    </Box>
  );
}

export default function App() {
  const { user } = useAuthentication();

  return (
    // Wraps the whole authenticated tree so one socket serves every feature
    // that subscribes to a topic below it.
    <WebSocketProvider userId={user?.id}>
      <SidebarProvider>
        <Navigation />
        <Main />
      </SidebarProvider>
    </WebSocketProvider>
  );
}
